import { useState } from "react";
import { ChevronDown, CheckCircle2 } from "lucide-react";

// Shared card chrome for every section on the Ocean manual-quote page —
// icon badge + title + optional right-aligned content, consistent shadow and
// spacing, PLUS click-to-collapse and a completion badge (green check once
// the section's required fields are filled) so the page reads as a guided
// flow instead of one long static form.
const SectionCard = ({
  id,
  icon: Icon,
  title,
  subtitle,
  right,
  bodyClassName,
  children,
  collapsible = true,
  defaultOpen = true,
  complete = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => collapsible && setOpen((o) => !o);

  return (
    <div
      id={id}
      className="bg-white rounded-2xl overflow-hidden transition-shadow hover:shadow-md"
      style={{ border: "1px solid #EDEEF1", boxShadow: "0 1px 3px rgba(16,24,40,.05)" }}
    >
      <div
        className={`flex items-center justify-between gap-3 flex-wrap px-5 py-4 ${collapsible ? "cursor-pointer select-none" : ""}`}
        style={{ borderBottom: open ? "1px solid #F1F2F5" : "none", background: "#FAFAFB" }}
        onClick={toggle}
      >
        <div className="flex items-center gap-3 min-w-0">
          <span
            className="w-9 h-9 rounded-xl flex items-center justify-center flex-none transition-colors"
            style={{ background: complete ? "#E7F8EF" : "#FFF3D6" }}
          >
            {complete ? (
              <CheckCircle2 size={18} style={{ color: "#12B76A" }} />
            ) : (
              Icon && <Icon size={17} style={{ color: "#B8860B" }} />
            )}
          </span>
          <div className="min-w-0">
            <div className="font-bold text-gray-800 text-[15px] leading-tight">{title}</div>
            {subtitle && <div className="text-xs text-gray-400 mt-0.5">{subtitle}</div>}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-none" onClick={(e) => e.stopPropagation()}>
          {right}
          {collapsible && (
            <button
              type="button"
              onClick={toggle}
              aria-label={open ? "Collapse section" : "Expand section"}
              className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors flex-none"
            >
              <ChevronDown
                size={16}
                style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .2s" }}
              />
            </button>
          )}
        </div>
      </div>

      {open && <div className={bodyClassName ?? "p-5"}>{children}</div>}
    </div>
  );
};

export default SectionCard;
